import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; // Import toast
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import { editWhyLuminarApi } from 'Services/allApi';
import { whyLuminarApi } from 'Services/allApi';

const WhyLuminar = () => {
    const [formData, setFormData] = useState({
        icon: '',
        content: '',
    
      });
    
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
    //   const [validationError, setValidationError] = useState('');
    
      // Fetch data on component mount
      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await whyLuminarApi();
            console.log("response", response);
            const data = response.data;
            if (response.error) {
              setError(response.message);
            } else {
              setFormData({
                icon: data.icon || '',
                content: data.content || '',
                
              });
            }
          } catch (err) {
            setError('Failed to fetch data. Please try again.');
          } finally {
            setLoading(false);
          }
        };
        fetchData();
      }, []);
    
      // Handle form input changes
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      
    
      // Handle the update button
      const handleUpdate = async () => {

          try {
            const response = await editWhyLuminarApi(1, formData); // Replace `1` with the actual id you want to use
            if (response.error) {
              toast.error("Failed to update. Please try again.");
            } else {
              toast.success("Why Luminar content updated successfully!");
            }
          } catch (error) {
            toast.error("Error updating home page bottom content.");
        }
      };
    
      if (loading) {
        return <div>Loading...</div>;
      }
    
      if (error) {
        return <div>Error: {error}</div>;
      }
  return (
    <>
        <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
      <h2 className="text-center text-3xl font-bold mb-5 mt-2">Why Luminar</h2>
      <hr className="mb-4" />

      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
        {/* Head Section 1 */}
        <div className="sm:col-span-4">
          <label htmlFor="icon" className="block font-medium text-gray-900">Icon</label>
          <div className="mt-2">
            <input
              type="text"
              name="icon"
              id="icon"
              value={formData.icon}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

        {/* Head Section 2 */}
        <div className="sm:col-span-4">
          <label htmlFor="content" className="block font-medium text-gray-900">content</label>
          <div className="mt-2">
            <input
              type="text"
              name="content"
              id="content"
              value={formData.content}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

    
        
      </div>
      <hr className="mt-5 mb-5" />

      {/* Update Button */}
      <div className="flex justify-center">
        <button
          type="button"
          onClick={handleUpdate}
          className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          Update
        </button>
      </div>
    </div>
    </>
  )
}

export default WhyLuminar